import { motion } from "framer-motion";
import { ECOSYSTEM } from "@/lib/data";

export const Ecosystem = () => {
  return (
    <section id="ecosystem" className="relative py-28 lg:py-36 bg-[#050505]" data-testid="ecosystem-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-16">
          <p className="text-[12px] tracking-[0.3em] uppercase text-white/40 mb-5">The Bigger Picture</p>
          <h2 className="font-heading uppercase tracking-tight text-white text-4xl lg:text-6xl leading-[0.95]">
            More than a <span className="font-serif-accent italic lowercase normal-case tracking-normal text-gold">producer</span>
          </h2>
          <p className="text-white/55 mt-6 leading-relaxed text-[15px] max-w-xl">
            Production is the foundation — but it's one part of a bigger picture across music, community and performance.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-white/10 border border-white/10 rounded-2xl overflow-hidden">
          {ECOSYSTEM.map((e, i) => (
            <motion.div
              key={e.no}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: (i % 2) * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="group bg-[#050505] p-9 lg:p-12 hover:bg-white/[0.03] transition-colors duration-500"
              data-testid={`engine-${i}`}
            >
              <div className="flex items-start justify-between gap-6">
                <span className="font-serif-accent italic text-5xl lg:text-6xl text-gold/50 leading-none group-hover:text-gold transition-colors duration-500">{e.no}</span>
                <span className="text-[10px] tracking-[0.2em] uppercase px-3 py-1 rounded-full border border-white/15 text-white/55 mt-2">{e.role}</span>
              </div>
              <h3 className="font-heading uppercase tracking-tight text-white text-2xl lg:text-3xl mt-8">{e.title}</h3>
              <p className="text-white/55 mt-3 leading-relaxed text-[15px] max-w-md">{e.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Ecosystem;
